const validateLiverGb=(formData)=>
{
    const message0= "NICE recommends:-" 

    const liverGbMessage= "Consider an urgent, direct access ultrasound scan (to be done within 2 weeks) to assess for gall bladder cancer in people with an upper abdominal mass consistent with an enlarged gall bladder.  Consider an urgent, direct access ultrasound scan (to be done within 2 weeks) to assess for liver cancer in people with an upper abdominal mass consistent with an enlarged liver."
    
    if (formData.LiverGbMass)
            {
            formData.message.liverGb=message0 + liverGbMessage
            formData.investigations.push("Abdominal Ultrasound")
            return formData
            }
    
        return formData
        }

        
export default validateLiverGb